import { useEstimate } from './context/EstimateContext'
import Shell from './components/Shell'
import SymptomStep from './steps/SymptomStep'
import PhotoStep from './steps/PhotoStep'
import ExtractingStep from './steps/ExtractingStep'
import VerdictStep from './steps/VerdictStep'
import BookingStep from './steps/BookingStep'
import ConfirmationStep from './steps/ConfirmationStep'

export default function App() {
  const { step } = useEstimate()

  return (
    <Shell>
      {step === 'symptom' && <SymptomStep />}
      {step === 'photo' && <PhotoStep />}
      {step === 'extracting' && <ExtractingStep />}
      {step === 'verdict' && <VerdictStep />}
      {step === 'booking' && <BookingStep />}
      {step === 'confirmation' && <ConfirmationStep />}
    </Shell>
  )
}
